var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"add-photo-icon"},[_c('PhotographIcon'),_c('PlusIcon')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }